import { useState } from "react";
import { Mail, AlertTriangle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const inp = "w-full h-11 rounded-2xl border border-pink-200 bg-white px-4 text-sm focus:outline-none focus:ring-2 focus:ring-rose-300";

export function EmailChangeCard() {
  const { user, refreshUser } = useAuth();
  const bad = !!user?.email_undeliverable;
  const [open, setOpen] = useState(bad);
  const [f, setF] = useState({ new_email: "", password: "" });
  const [busy, setBusy] = useState(false);
  if (!user) return null;
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-email", f);
      toast.success(`Gespeichert! Wir haben eine Bestätigungs-Mail an ${data.email} geschickt 💌`);
      setF({ new_email: "", password: "" }); setOpen(false); refreshUser?.();
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className={`rounded-3xl p-6 border space-y-3 ${bad ? "bg-red-50 border-red-200" : "bg-white border-pink-100"}`} data-testid="email-change-card">
      {bad && (
        <p className="flex gap-2 text-sm font-semibold text-red-700" data-testid="email-undeliverable-notice">
          <AlertTriangle className="w-5 h-5 shrink-0" />
          <span>An deine E-Mail-Adresse <b className="break-all">{user.email}</b> können wir nichts zustellen. Bitte korrigiere sie, damit du Passwort-Links, Bestätigungen und Tassen-Infos bekommst.</span>
        </p>
      )}
      <div className="flex items-center gap-3">
        <Mail className="w-5 h-5 text-rose-500 shrink-0" />
        <div className="min-w-0 flex-1"><h3 className="font-bold">E-Mail-Adresse</h3><p className="text-sm text-slate-500 break-all" data-testid="email-current">{user.email}</p></div>
        {!open && <button type="button" onClick={() => setOpen(true)} data-testid="email-change-open" className="shrink-0 h-9 px-4 rounded-full bg-rose-50 text-rose-600 text-sm font-bold">Ändern</button>}
      </div>
      {open && (user.has_password === false ? (
        <p className="text-sm text-slate-500" data-testid="email-change-social">Du meldest dich über Google oder Facebook an. Lege zuerst über „Passwort vergessen“ ein Passwort fest, dann kannst du deine E-Mail-Adresse hier ändern.</p>
      ) : (
        <div className="space-y-2.5">
          <input type="email" value={f.new_email} onChange={(e) => setF({ ...f, new_email: e.target.value })} placeholder="Neue E-Mail-Adresse" autoComplete="email" className={inp} data-testid="email-change-new" />
          <input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="Dein aktuelles Passwort" autoComplete="current-password" className={inp} data-testid="email-change-password" />
          <div className="flex gap-2">
            <button type="button" onClick={save} disabled={busy || !f.new_email.includes("@") || !f.password} data-testid="email-change-submit" className="flex-1 h-11 rounded-full bg-gradient-to-r from-rose-500 to-pink-500 text-white font-bold disabled:opacity-50 inline-flex items-center justify-center gap-2">{busy && <Loader2 className="w-4 h-4 animate-spin" />} E-Mail speichern</button>
            {!bad && <button type="button" onClick={() => setOpen(false)} data-testid="email-change-cancel" className="h-11 px-4 rounded-full text-slate-500 font-semibold">Abbrechen</button>}
          </div>
        </div>
      ))}
    </div>
  );
}
